/* eslint-disable max-lines */
/* eslint-disable no-magic-numbers */
import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import cx from 'classnames';
import { getFeaturedAdSelector } from 'Selectors/items';
import Slider from 'react-slick';
import Auth from '../../Auth';
import GalleryContent from './GalleryContent.APP_TARGET';
import { Card } from 'panamera-react-ui';
import FullScreenImageGallery from 'Components/FullScreenImageGallery/FullScreenImageGalleryAsync';
import FullScreenImageGalleryV2 from 'Components/FullScreenImageGalleryV2/FullScreenImageGalleryV2Async';
import DotsLazyLoaded from 'Components/ImageGalleryDots/ImageGalleryDotsLoazyLoaded';
import withRouter from 'HOCs/withRouter';
import { FormattedMessage as Translation } from 'react-intl';
import withDirection from 'HOCs/withDirection/withDirection';
import withTrack from 'HOCs/withTrack/withTrack';
import Icon from 'Components/ThematicIcon/ThematicIcon';

import css from './ImageGallery.APP_TARGET.scss';
import GalleryThumbnails from 'Components/GalleryThumbnails/GalleryThumbnails';
import { ICON_COLORS } from 'Constants/items';
import { fileNames } from 'Constants/imageUrls';
import ImageWrapper from 'Components/ImageWrapper/ImageWrapper';
import { isMobile } from 'Helpers/devices';
import { AI_VIDEO_ADS_VARIANT } from 'Constants/constants';
import { withConfig } from 'HOCs/withConfig/withConfig';
import withVwo from 'HOCs/withVwo/withVwo';
import { configSelector } from 'Selectors/config';
import { setVideoAvailableVariant } from 'Actions/videoAvailableVariant';
import { getAIGeneratedAdsVideoConfig, showVideoPlayerBasedOnConfig } from 'Helpers/aiGeneratedAdsVideo';

const MAX_CAROUSEL_DOTS = 6;

export class ImageGallery extends React.PureComponent {
    static propTypes = {
        images: PropTypes.array,
        itemStatus: PropTypes.object,
        title: PropTypes.string,
        isMyItem: PropTypes.bool,
        isItemOutdated: PropTypes.bool,
        arrows: PropTypes.bool,
        slidesToShow: PropTypes.number,
        imageSize: PropTypes.string,
        imageHeight: PropTypes.string,
        imageLoadCallback: PropTypes.func,
        location: PropTypes.object,
        router: PropTypes.object,
        isFeatured: PropTypes.bool.isRequired,
        showFeaturedTag: PropTypes.bool,
        imageWrapperClassname: PropTypes.string,
        className: PropTypes.string,
        direction: PropTypes.oneOf(['rtl', 'ltr']),
        track: PropTypes.func.isRequired,
        trackImageTap: PropTypes.func,
        trackImagePagination: PropTypes.func,
        setCurrIdx: PropTypes.func,
        children: PropTypes.node,
        isPreview: PropTypes.bool,
        showLabel: PropTypes.bool,
        showSliderArrows: PropTypes.bool,
        showDots: PropTypes.bool,
        fullScreenHash: PropTypes.string,
        showThumbsContainer: PropTypes.bool,
        dotSize: PropTypes.number,
        customSliderCss: PropTypes.string,
        showIndex: PropTypes.bool,
        selectedImgIdx: PropTypes.number,
        useFullScreenGalleryV2: PropTypes.bool,
        newThumbsVariant: PropTypes.bool,
        thumbsContainerClassName: PropTypes.string,
        descriptionComponent: PropTypes.node,
        labelClassName: PropTypes.node,
        thumbsClassName: PropTypes.string,
        thumbClassName: PropTypes.string,
        selectedThumbClassName: PropTypes.string,
        enableZoom: PropTypes.bool,
        responsiveSettings: PropTypes.array,
        disableImgOptimization: PropTypes.bool,
        fullScreenEnabled: PropTypes.bool,
        updateImageOnChange: PropTypes.bool,
        showThumbnails: PropTypes.bool,
        staticAssetUrl: PropTypes.string,
        align: PropTypes.string,
        stretchImage: PropTypes.bool,
        dotsAlign: PropTypes.string,
        hasPromotion: PropTypes.bool,
        isVideoGenerated: PropTypes.bool,
        videoUrl: PropTypes.string,
        videoAvailableVariant: PropTypes.string,
        adpvTxnRevamp: PropTypes.bool,
        marketConfig: PropTypes.object.isRequired,
        videoBadgeFeatureConfig: PropTypes.object,
        vwoClientInstance: PropTypes.shape({
            activate: PropTypes.func.isRequired,
            track: PropTypes.func.isRequired
        }),
        setVideoAvailableVariant: PropTypes.func,
        monetizationInfo: PropTypes.object
    };

    static defaultProps = {
        updateItemGalleryPath: () => { },
        imageLoadCallback: () => { },
        images: [],
        itemStatus: {},
        title: '',
        isMyItem: false,
        isItemOutdated: false,
        arrows: false,
        slidesToShow: 8,
        imageWrapperClassname: '',
        className: '',
        trackImageTap: () => { },
        trackImagePagination: () => { },
        setCurrIdx: () => { },
        isPreview: false,
        showLabel: false,
        showSliderArrows: false,
        showDots: false,
        fullScreenHash: 'gallery',
        showThumbsContainer: true,
        dotSize: 6,
        showIndex: true,
        selectedImgIdx: 0,
        useFullScreenGalleryV2: false,
        newThumbsVariant: false,
        enableZoom: false,
        showFeaturedTag: false,
        fullScreenEnabled: true,
        updateImageOnChange: true,
        showThumbnails: false,
        staticAssetUrl: '',
        hasPromotion: false,
        isVideoGenerated: false,
        videoUrl: '',
        videoAvailableVariant: '',
        adpvTxnRevamp: false,
        marketConfig: () => { },
        videoBadgeFeatureConfig: null,
        vwoClientInstance: {
            track: () => {},
            activate: () => {}
        },
        setVideoAvailableVariant: () => {},
        monetizationInfo: {}
    };

    constructor(props) {
        super(props);
        this.state = {
            initialSlide: 0,
            loggedUser: Auth.getUser(),
            slideIndex: 0
        };
        this.shouldFireTracking = true;
    }

    componentDidMount() {
        const { isVideoGenerated, videoUrl, videoBadgeFeatureConfig, vwoClientInstance, setVideoAvailableVariant } = this.props;
        const isVideoAvailable = isVideoGenerated && videoUrl;

        const isShowVideoPlayer = showVideoPlayerBasedOnConfig(videoBadgeFeatureConfig, isVideoAvailable, vwoClientInstance.activate, isMobile);

        setVideoAvailableVariant(isShowVideoPlayer);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.selectedImgIdx !== this.props.selectedImgIdx) {
            this.shouldFireTracking = false;
            this.slider.slickGoTo(this.props.selectedImgIdx);
        }
    }

    goTo = e => this.slider.slickGoTo(parseInt(e.target.value, 10));

    next = ev => {
        ev.stopPropagation();
        this.slider.slickNext();
    }

    previous = ev => {
        ev.stopPropagation();
        this.slider.slickPrev();
    }

    toggleFullScreen = (initialSlide = 0) => {
        const toggleScreen = slide => {
            this.setState({ initialSlide: slide });
            this.resolveUrl(slide);
            if (this.slider) {
                this.slider.slickGoTo(slide);
            }
        };

        const isGeneratedVideoNotExist = !this.props.videoUrl && !this.props.isVideoGenerated;
        const isCurrentlyFullScreeen = this.props.location && this.isItFullScreened(this.props.location.hash);

        if (isGeneratedVideoNotExist) {
            toggleScreen(initialSlide);
            return;
        }

        if (isCurrentlyFullScreeen && initialSlide > 0) {
            toggleScreen(initialSlide + 1);
            return;
        }

        toggleScreen(initialSlide);
    };

    getNameLabel() {
        const img = this.props.images[this.state.slideIndex];
        const name = img && img.name;

        return name && this.props.showLabel ? <span className={ cx(css.nameLabel, this.props.labelClassName) } >{name}</span> : null;
    }

    resolveUrl = slideIndex => {
        const { location, itemStatus, fullScreenHash, trackImageTap, router } = this.props;
        const { pathname, search, hash, state: routeState } = location;
        const trackingInfo = {
            resultset_type: 'browse',
            page_number: slideIndex + 1,
            item_status: itemStatus.status
        };

        if (this.isItFullScreened(hash)) {
            trackImageTap(trackingInfo);
            if (routeState && routeState.fromItemPage) {
                return router.goBack();
            }
            return router.push({
                pathname,
                search
            });
        }
        trackImageTap(trackingInfo, true);

        return router.push({
            pathname,
            search,
            hash: `#${fullScreenHash}`
        }, {
            state: { fromItemPage: true }
        });
    };

    beforeImageChange = (_, nextIndex, isFromFullScreenGallery = true) => {
        const isFullScreen = this.props.location && this.isItFullScreened(this.props.location.hash);
        const trackingInfo = {
            resultset_type: 'browse',
            page_number: nextIndex + 1,
            select_from: isFullScreen ? 'overview' : 'itempage'
        };

        const isGeneratedVideoNotExist = !this.props.videoUrl && !this.props.isVideoGenerated;
        const isCurrentlyFullScreeen = this.props.location && this.isItFullScreened(this.props.location.hash);

        if (isGeneratedVideoNotExist) {
            if (this.shouldFireTracking && (!isFullScreen || isFromFullScreenGallery)) {
                this.props.trackImagePagination(trackingInfo, this.props.images[nextIndex].url, isFullScreen);
            }

            if (!this.props.updateImageOnChange && isFromFullScreenGallery) {
                return;
            }

            this.props.setCurrIdx(nextIndex);
            if (this.slider) {
                this.slider.slickGoTo(nextIndex);
            }
        }

        if (isCurrentlyFullScreeen && nextIndex > 0) {
            if (this.shouldFireTracking && (!isFullScreen || isFromFullScreenGallery)) {
                this.props.trackImagePagination(trackingInfo, this.props.images[nextIndex - 1].url, isFullScreen);
            }

            if (!this.props.updateImageOnChange && isFromFullScreenGallery) {
                return;
            }

            this.props.setCurrIdx(nextIndex - 1);
            if (this.slider) {
                this.slider.slickGoTo(nextIndex - 1);
            }
        }

        this.setState({ slideIndex: nextIndex });
    }

    afterImageChange = (i, fullScreen = true) => {
        this.props.imageLoadCallback(i + 1, fullScreen);
        this.shouldFireTracking = true;

        if (fullScreen && !this.props.updateImageOnChange) {
            return;
        }
        this.setState({ slideIndex: i });
    };

    isItFullScreened = hash => hash === `#${this.props.fullScreenHash}`;

    handleCardClick = () => {
        if (this.props.fullScreenEnabled) {
            if (this.props.videoAvailableVariant === 'AI-ON') {
                if (!this.props.videoUrl && !this.props.isVideoGenerated) {
                    this.toggleFullScreen(this.state.slideIndex);
                    return;
                }

                if (this.state.slideIndex === 0) {
                    this.toggleFullScreen(this.state.slideIndex);
                    return;
                }

                if (this.state.slideIndex > 1) {
                    this.toggleFullScreen(this.state.slideIndex - 1);
                    return;
                }
            }
            else {
                this.toggleFullScreen(this.state.slideIndex);
                return;
            }
        }
    }

    handleThumbsContainerClick = ev => {
        ev.stopPropagation();
    }

    render() {
        const { location, title, useFullScreenGalleryV2, newThumbsVariant, isVideoGenerated, videoUrl, videoAvailableVariant } = this.props;
        const fullScreen = location && this.isItFullScreened(location.hash);
        const externalId = this.props?.marketConfig?.get('dailyMotionPlayerId');
        const showVideoPlayer = videoAvailableVariant === AI_VIDEO_ADS_VARIANT.AI_ON;

        let arrows = null;

        const updatedImages = [
            ...this.props.images.slice(0, 1),
            {
                url: '',
                id: videoUrl,
                external_id: isMobile ? externalId?.mobile : externalId?.desktop
            },
            ...this.props.images.slice(1)
        ];

        const slideLength = isVideoGenerated && videoUrl && showVideoPlayer ? updatedImages.length : this.props.images.length;

        const slideIndexTotal = (
            <div className={ cx(css.indexTotal, { [css.desktopTopIndexTotal]: this.props.showThumbsContainer && (this.props.images.length > 1) }) } >
                {`${this.state.slideIndex + 1} / ${slideLength}`}
            </div>
        );

        if (this.props.images.length > 1) {
            arrows = (
                <>
                    <span className={ cx(css.arrows, css.prev) } onClick={ this.previous }>
                        <Icon icon="arrowLeft" direction={ this.props.direction } size={ 30 } color="whiteIcons" />
                    </span>
                    <span className={ cx(css.arrows, css.next) } onClick={ this.next }>
                        <Icon icon="arrowRight" direction={ this.props.direction } size={ 30 } color="whiteIcons" />
                    </span>
                </>
            );
        }

        const galleryContentVideo = updatedImages.map((image, idx) => (
            <div key={ `gallery-content-${title}-${idx}` }>
                <GalleryContent
                    image={ image }
                    title={ this.props.title }
                    imageSize={ this.props.imageSize }
                    imageHeight={ this.props.imageHeight }
                    enableZoom={ this.props.enableZoom }
                    isActive={ this.state.slideIndex === idx }
                    adpvTxnRevamp={ this.props.adpvTxnRevamp }
                    disableImgOptimization={ this.props.disableImgOptimization }
                />
            </div>
        ));

        const galleryContent = this.props.images.map((image, idx) => (
            <div key={ `gallery-content-${title}-${idx}` }>
                <GalleryContent
                    image={ image }
                    title={ this.props.title }
                    imageSize={ this.props.imageSize }
                    imageHeight={ this.props.imageHeight }
                    enableZoom={ this.props.enableZoom }
                    isActive={ this.state.slideIndex === idx }
                    disableImgOptimization={ this.props.disableImgOptimization }
                    stretchImage={ this.props.stretchImage }
                />
            </div>
        ));

        const gallerySettings = {
            dots: false,
            speed: 500,
            arrows: this.props.arrows,
            infinite: this.props.images.length > 1,
            lazyLoad: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            currentSlide: 0,
            rtl: this.props.direction === 'rtl',
            className: cx(css.slider, this.props.customSliderCss),
            beforeChange: (current, next) => this.beforeImageChange(current, next, false),
            afterChange: i => this.afterImageChange(i, false),
            asNavFor: this.thumbsSlider
        };

        const thumbsSettings = {
            speed: 500,
            dots: false,
            arrows: false,
            infinite: true,
            slidesToShow: this.props.slidesToShow,
            slidesToScroll: 1,
            className: cx(css.thumbs, this.props.thumbsClassName),
            responsive: this.props.responsiveSettings,
            asNavFor: this.slider,
            focusOnSelect: true,
            swipeToSlide: true,
            ref: thumbsSlider => (this.thumbsSlider = thumbsSlider)
        };

        return (
            <Card
                className={ cx(
                    css.imageGallery,
                    this.props.className,
                    { [css.disabled]: this.props.isMyItem && this.props.isItemOutdated },
                    css.lessHeight,
                    { [css.imageGalleryII]: this.props.align === 'right' }
                ) }
                contentClassName={ css.imageGalleryContent }
                onClick={ this.handleCardClick }
            >
                {this.props.isPreview
                    && <label className={ css.preview }>
                        <Translation id="listing_ad_preview_label" />
                    </label>
                }
                <div className={ css.mainGalleryContainer }>
                    {this.props.hasPromotion
                    && <ImageWrapper
                        fileName={ fileNames.DISCOUNT_ICON_EXTRA_LARGE }
                        className={ css.discountImage }
                    />
                    }
                    <Slider ref={ slider => (this.slider = slider) } { ...gallerySettings }>
                        {isVideoGenerated && videoUrl && showVideoPlayer ? galleryContentVideo : galleryContent}
                    </Slider>
                    {this.props.showSliderArrows && arrows}
                </div>
                {
                    this.props.showIndex
                    && slideIndexTotal
                }

                {this.getNameLabel()}

                {this.props.showDots && (this.props.images.length > 1)
                    && (<DotsLazyLoaded
                        length={ this.props.images.length }
                        active={ this.state.slideIndex }
                        size={ this.props.dotSize }
                        visible={ MAX_CAROUSEL_DOTS }
                        margin={ 3 }
                        className={ cx(css.carouselDots, {
                            [css.centerAligned]: this.props.images.length < MAX_CAROUSEL_DOTS || this.props.dotsAlign === 'center',
                            [css.rightAligned]: this.props.dotsAlign === 'right'
                        }) }
                    />)
                }
                {this.props.descriptionComponent}
                { this.props.showThumbsContainer && <GalleryThumbnails
                    images={ this.props.images }
                    settings={ thumbsSettings }
                    title={ this.props.title }
                    slideIndex={ this.state.slideIndex }
                    direction={ this.props.direction }
                    newThumbsVariant={ newThumbsVariant }
                    selectedThumbClassName={ this.props.selectedThumbClassName }
                    thumbClassName={ cx(css.thumb, this.props.thumbClassName) }
                    thumbsContainerClassName={ this.props.thumbsContainerClassName }
                    showArrow={ this.props.images.length > this.props.slidesToShow }
                    arrowIconSize={ newThumbsVariant ? 30 : 20 }
                    arrowIconColor={ newThumbsVariant ? ICON_COLORS.WHITE_ICONS : ICON_COLORS.BLACK_DISABLED }
                    handleNext={ this.next }
                    handlePrev={ this.previous }
                    handleItemClick={ this.goTo }
                    handleThumbsContainerClick={ this.handleThumbsContainerClick }
                />}
                {fullScreen && !useFullScreenGalleryV2 && (
                    <FullScreenImageGallery
                        images={ this.props.images }
                        toggleFullScreen={ this.toggleFullScreen }
                        initialSlide={ this.state.initialSlide }
                        track={ this.props.track }
                        alt={ this.props.title }
                        beforeChange={ this.beforeImageChange }
                        onChange={ this.afterImageChange }
                        imageWrapperClassname={ this.props.imageWrapperClassname }
                        showThumbnails={ this.props.showThumbnails }
                    />
                )}
                { fullScreen && useFullScreenGalleryV2 && (
                    <FullScreenImageGalleryV2
                        images={ this.props.images }
                        onClose={ this.toggleFullScreen }
                        initialIdx={ this.state.initialSlide }
                        track={ this.props.track }
                        alt={ this.props.title }
                        beforeChange={ this.beforeImageChange }
                        onChange={ this.afterImageChange }
                        imageWrapperClassname={ this.props.imageWrapperClassname }
                        dots
                    />
                )}
                {this.props.children}
                {this.props.showIndex
                    && <div className={ css.bottomGradient } />
                }
            </Card>
        );
    }
}

export const mapStateToProps = (state, props) => ({
    isFeatured: getFeaturedAdSelector(state, props),
    videoAvailableVariant: state.videoAvailableVariant?.variant || '',
    videoBadgeFeatureConfig: getAIGeneratedAdsVideoConfig(configSelector(state)?.features)
});

export const mapDispatchToProps = dispatch => ({
    setVideoAvailableVariant: variant => dispatch(setVideoAvailableVariant(variant))
});

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    withRouter,
    withDirection,
    withTrack,
    withConfig('marketConfig'),
    withVwo
)(ImageGallery);

